import { Controller } from "@hotwired/stimulus"

// A Common::Dialog that lives INSIDE a form: the radio inputs in the dialog
// stay part of the surrounding form, so no value-copying is needed. Used by
// the project icon picker (TASK-81.10), the report-branding picker
// (TASK-105/133.3), and the report designer's source picker. Selecting an
// option updates the trigger button's preview and closes the dialog.
//
// `cancel` / `backdropClose` are the method names Common::Dialog::Component
// wires up for any controller it's given it (see
// docs/view_components/common/dialog.md) — this is a domain controller in
// the same sense as logo_upload_controller.js, not the shared
// dialog_controller.js.
export default class extends Controller {
  static targets = [ "dialog", "backdrop", "preview", "label" ]

  open(event) {
    if (event) event.preventDefault()
    this.dialogTarget.showModal()
  }

  cancel(event) {
    if (event) event.preventDefault()
    this.dialogTarget.close()
  }

  backdropClose(event) {
    if (event.target === this.backdropTarget) this.cancel(event)
  }

  select(event) {
    const optionLabel = event.target.closest("label")
    if (this.hasPreviewTarget && optionLabel) {
      const preview = optionLabel.querySelector("[data-picker-preview]")
      if (preview) this.previewTarget.innerHTML = preview.innerHTML
    }
    if (this.hasLabelTarget) {
      this.labelTarget.textContent = event.target.dataset.pickerLabel || event.target.value
    }
    this.dialogTarget.close()
  }
}
